/*
 * @Description:
 * @Date: 2020-07-18 16:13:15
 */

import { BI } from '@/api/ajax';
import combination from './combination';
import { moneyInt } from '@/tools/money';
import { percentage } from '@/tools/index';
import {
  createBarSeries,
  createLineSeries,
  createMapSeries1
} from '../components/Echarts/echartOption';
import { dealTips } from '../tools/index';

// let dashedPic =
//   'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM8AAAAOBAMAAAB6G1V9AAAAD1BMVEX////Kysrk5OTj4+TJycoJ0iFPAAAAG0lEQVQ4y2MYBaNgGAMTQQVFOiABhlEwCugOAMqzCykGOeENAAAAAElFTkSuQmCC';

export default {
  query: {},
  // 上部分
  ...combination,
  queryOtcVisitTimeInfo() {
    return new Promise(async resolve => {
      let {
        data: { data: resp }
      } = await BI[this.query.serviceType].queryOtcVisitTimeInfo(this.query);
      let { timeday } = resp || {
        timehour: [],
        timeday: [],
        finalDataCount: 0
      };
      let timedayXAxisData = [];
      let timedaySeries0data = [];
      timeday.forEach((item, index) => {
        timedayXAxisData[index] = [];
        timedaySeries0data[index] = [];
        let [m] = Object.entries(item);
        let days = Object.entries(m[1]);
        days.forEach(i => {
          timedayXAxisData[index].push(i[0]);
          timedaySeries0data[index].push(i[1]);
        });
      });
      resolve({
        key: 'queryOtcVisitTimeInfo',
        value: {
          header: {
            index: 1,
            title: '巡店时间',
            name: '巡店时间'
          },
          echart: [
            {
              echartType: 'line1',
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '单');
                  }
                },
                xAxis: {
                  type: 'category',
                  data: timedayXAxisData[0],
                  name: '日'
                },
                yAxis: {
                  name: '任务数（单）'
                },
                series0data: timedaySeries0data
              }
            }
          ]
        }
      });
    });
  },
  queryOtcVisitTimeInfo1() {
    return new Promise(async resolve => {
      let {
        data: { data: resp }
      } = await BI[this.query.serviceType].queryOtcVisitTimeInfo(this.query);
      let { timehour, finalDataCount } = resp || {
        timehour: [],
        timeday: [],
        finalDataCount: 0
      };
      let header = [
        { label: '时间段', prop: 'd' },
        { label: '任务数（单）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let data = [];
      let xAxisData = [];
      let series0data = [];
      timehour.forEach(item => {
        let [m] = Object.entries(item);
        xAxisData.push(m[0]);
        series0data.push(m[1]);
        const [x1, x2] = (m[0] || '').split('-');
        data.push({
          d: `${x1}-<br>${x2}`,
          v: m[1],
          b: percentage(m[1], finalDataCount)
        });
      });
      resolve({
        key: 'queryOtcVisitTimeInfo1',
        value: {
          header: {
            hideHeader: true,
            title: '每日时间分布',
            name: '每日时间分布'
          },
          table: { header, data, finalDataCount },
          echart: [
            {
              echartType: 'bar2',
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '单');
                  }
                },
                xAxis: {
                  type: 'category',
                  data: xAxisData,
                  axisLabel: {
                    interval: 0,
                    textStyle: {
                      color: '#666',
                      fontSize: 12
                    }
                  }
                },
                yAxis: {
                  name: '任务数（单）'
                },
                series: createBarSeries(series0data, true)
              }
            }
          ]
        }
      });
    });
  },
  queryOtcProductPriceInfo() {
    return new Promise(async resolve => {
      let {
        data: { data: resp }
      } = await BI[this.query.serviceType].queryOtcProductPriceInfo(this.query);
      let { finalDataCount, productPrice, finalDataMap } = resp || {
        finalDataCount: 0,
        productPrice: 0,
        finalDataMap: []
      };
      let header = [
        { label: '产品售价（元）', prop: 'd' },
        { label: '药店数（家）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let data = [];
      let xAxisData = [];
      let series0data = [];
      // let formatData = {};
      // finalData = finalData.sort((a, b) => b - a);
      // finalData.forEach(item => {
      //   let money = moneyInt(item);
      //   let min = Math.min(101, money);
      //   formatData[min] = formatData[min] ? formatData[min] + 1 : 1;
      // });
      finalDataMap.forEach(item => {
        let [m] = Object.entries(item);
        xAxisData.push(m[0]);
        series0data.push(m[1]);
        data.push({
          d: m[0],
          v: m[1],
          b: percentage(m[1], finalDataCount)
        });
      });

      resolve({
        key: 'queryOtcProductPriceInfo',
        value: {
          header: {
            index: 3,
            title: '产品售价',
            name: `产品售价（全国指导价：${moneyInt(productPrice)}元）`
          },
          table: { header, data, finalDataCount },
          echart: [
            {
              echartType: 'line',
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '家');
                  }
                },
                xAxis: {
                  type: 'category',
                  data: xAxisData,
                  name: '元'
                },
                yAxis: {
                  name: '药店数（家）'
                },
                series: createLineSeries(series0data)
              }
            }
          ]
        }
      });
    });
  },
  queryOtcCustomerProductInfo() {
    return new Promise(async resolve => {
      let {
        data: { data: resp }
      } = await BI[this.query.serviceType].queryOtcCustomerProductInfo(
        this.query
      );
      let {
        displayStatus,

        popDataMap,
        knowDataMap,
        finalDataCount,
        stockListMap
      } = resp || {
        displayStatus: {},
        stockList: [],
        popDataMap: {},
        knowDataMap: {},
        finalDataCount: 0,
        stockListMap: []
      };
      // 陈列状态
      // let displayStatusheader = [
      //   { label: '状态', prop: 'd' },
      //   { label: '数量（份）', prop: 'v' },
      //   { label: '百分比(%)', prop: 'b' }
      // ];
      let displayStatusdata = [];
      let displayStatusseries0data = [];
      let displayStatusMap = ['优秀', '合格', '不合格'];
      Object.entries(displayStatus).forEach(item => {
        displayStatusseries0data.push({
          value: item[1],
          name: displayStatusMap[item[0] - 1] + `：${item[1]}份`,
          b: percentage(item[1], finalDataCount) + '%'
        });
        displayStatusdata.push({
          d: displayStatusMap[item[0] - 1],
          v: item[1],
          b: percentage(item[1], finalDataCount)
        });
      });

      // 库存
      let stockListheader = [
        { label: '区间', prop: 'd' },
        { label: '任务数（单）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let stockListdata = [];
      let stockListxAxisData = [];
      let stockListseries0data = [];

      stockListMap.forEach(item => {
        let [m] = Object.entries(item);
        stockListxAxisData.push(m[0]);
        stockListseries0data.push(m[1]);
        stockListdata.push({
          d: m[0],
          v: m[1],
          b: percentage(m[1], finalDataCount)
        });
      });

      // 产品POP
      let popDataMapheader = [
        { label: '选项', prop: 'd' },
        { label: '任务数（单）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let popDataMapdata = [];
      let popDataMapseries0data = [];
      let popDataMapMap = ['否', '是'];
      // let popDataMapColor = ['#FF8700', '#ffc300', '#00e473', '#009DFF'];
      // let popDataMapSeries = [];
      // let popDataMapLineYAxis = [];

      Object.entries(popDataMap).forEach(item => {
        popDataMapdata.push({
          d: popDataMapMap[item[0]],
          v: item[1],
          b: percentage(item[1], finalDataCount)
        });
        popDataMapseries0data.push({
          name: popDataMapMap[item[0]],
          value: item[1],
          b: `${item[1]}单`
        });
        // popDataMapSeries.push({
        //   type: 'pie',
        //   clockWise: false,
        //   hoverAnimation: false,
        //   radius: [75 - i * 15 + '%', 67 - i * 15 + '%'],
        //   center: ['40%', '50%'],
        //   label: {
        //     show: false
        //   },
        //   data: [
        //     {
        //       value: item[1],
        //       name: popDataMapMap[item[0]]
        //     },
        //     {
        //       value: finalDataCount - item[1],
        //       name: '',
        //       itemStyle: {
        //         color: 'rgba(0,0,0,0)'
        //       }
        //     }
        //   ]
        // });
        // popDataMapSeries.push({
        //   type: 'pie',
        //   silent: true,
        //   z: 1,
        //   clockWise: false, //顺时加载
        //   hoverAnimation: false, //鼠标移入变大
        //   radius: [75 - i * 15 + '%', 67 - i * 15 + '%'],
        //   center: ['40%', '50%'],
        //   label: {
        //     show: false
        //   },
        //   data: [
        //     {
        //       value: 7.5,
        //       itemStyle: {
        //         color: '#E3F0FF'
        //       }
        //     },
        //     {
        //       value: 2.5,
        //       name: '',
        //       itemStyle: {
        //         color: 'rgba(0,0,0,0)'
        //       }
        //     }
        //   ]
        // });
        // popDataMapLineYAxis.push({
        //   value: i,
        //   textStyle: {
        //     rich: {
        //       circle: {
        //         color: popDataMapColor[i],
        //         padding: [0, 5]
        //       }
        //     }
        //   }
        // });
      });
      // let popDataMapOption = {
      //   color: popDataMapColor,
      //   grid: {

      //     containLabel: false
      //   },
      //   yAxis: {
      //     type: 'category',
      //     inverse: true,
      //     axisLine: {
      //       show: false
      //     },
      //     axisTick: {
      //       show: false
      //     },
      //     axisLabel: {
      //       formatter(params) {

      //         return '{line|}{name|'+ 3 +'}{bd||}{percent|'+2+'}{value|'+ 21+'}{unit|元}'

      //       },
      //       interval: 0,
      //       inside: true,
      //       textStyle: {
      //         color: '#333',
      //         fontSize: 14,
      //         rich: {
      //           line: {
      //             width: 170,
      //             height: 10,
      //             backgroundColor: { image: dashedPic }
      //           },
      //           name: {
      //             color: '#666',
      //             fontSize: 14
      //           },
      //           bd: {
      //             color: '#ccc',
      //             padding: [0, 5],
      //             fontSize: 14
      //           },
      //           percent: {
      //             color: '#333',
      //             fontSize: 14
      //           },
      //           value: {
      //             color: '#333',
      //             fontSize: 16,
      //             fontWeight: 500,
      //             padding: [0, 0, 0, 20]
      //           },
      //           unit: {
      //             fontSize: 14
      //           }
      //         }
      //       },
      //       show: true
      //     },
      //     data: popDataMapLineYAxis
      //   },
      //   xAxis: {
      //     show: false
      //   },
      //   series: popDataMapSeries
      // };

      // 是否知道卖点
      let knowDataMapheader = [
        { label: '选项', prop: 'd' },
        { label: '任务数（单）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let knowDataMapdata = [];
      let knowDataMapseries0data = [];
      let knowDataMapMap = ['不知道', '知道'];
      Object.entries(knowDataMap).forEach(item => {
        knowDataMapseries0data.push({
          value: item[1],
          name: knowDataMapMap[item[0]]
        });
        knowDataMapdata.push({
          d: knowDataMapMap[item[0]],
          v: item[1],
          b: percentage(item[1], finalDataCount)
        });
      });
      resolve([
        {
          key: 'displayStatus',
          value: {
            header: {
              index: 4,
              title: '陈列状态',
              name: '陈列状态'
            },
            customComponents: [
              {
                options: {
                  series0data: displayStatusseries0data,
                  finalDataCount: finalDataCount
                },
                com: require('../components/customCharts/pieGroup').default
              }
            ]
          }
        },
        {
          key: 'stockList',
          value: {
            header: {
              index: 5,
              title: '库存',
              name: '库存'
            },
            table: {
              header: stockListheader,
              data: stockListdata,
              finalDataCount
            },
            echart: [
              {
                echartType: 'line2',
                echartOption: {
                  tooltip: {
                    formatter: function(params) {
                      const { axisValue, value } = params[0] || params || {};
                      return dealTips(axisValue, value, '单');
                    }
                  },
                  yAxis: {
                    name: '任务数（单）'
                  },
                  xAxis: {
                    data: stockListxAxisData
                  },
                  series0data: stockListseries0data
                }
              }
            ]
          }
        },
        {
          key: 'popDataMap',
          value: {
            header: {
              index: 6,
              title: '是否有产品POP',
              name: '是否有产品POP'
            },
            customComponents: [
              {
                options: {
                  table: {
                    header: popDataMapheader,
                    data: popDataMapdata,
                    finalDataCount,
                    isNormal: true
                  },
                  series0data: popDataMapseries0data,
                  finalDataCount: finalDataCount
                },
                com: require('../components/customCharts/pie3dType1').default
              }
            ]
          }
        },
        {
          key: 'knowDataMap',
          value: {
            header: {
              index: 7,
              title: '店员是否知道卖点',
              name: '店员是否知道卖点'
            },
            customComponents: [
              {
                options: {
                  table: {
                    header: knowDataMapheader,
                    data: knowDataMapdata,
                    finalDataCount,
                    isNormal: true
                  },
                  series0data: knowDataMapseries0data,
                  finalDataCount: finalDataCount
                },
                com: require('../components/customCharts/bar3dType1').default
              }
            ]
          }
        }
      ]);
    });
  },
  queryOtcMap() {
    return new Promise(async resolve => {
      let {
        data: {
          data: { resultList }
        }
      } = await BI[this.query.serviceType].queryOtcTaskLocationInfo(this.query);
      resolve({
        key: 'queryOtcMap',
        value: {
          header: {
            title: '药店定位',
            name: '药店定位'
          },
          useMapLayout: false,
          echart: [
            {
              echartType: 'map',
              echartStyle: { height: '500px' },
              echartOption: {
                series: createMapSeries1(resultList)
              }
            }
          ]
        }
      });
    });
  },
  // 药店定位，TODO:暂无
  // querytaskHospitalDistribution() {
  //   return new Promise(async (resolve, reject) => {
  //     let {
  //       data: {
  //         data: { finalData, finalDataCount }
  //       }
  //     } = await BI[this.query.serviceType].querytaskHospitalDistribution(this.query);
  //     let header = [
  //       { label: '地名', prop: 'd' },
  //       { label: '药店数量（家）', prop: 'v' },
  //       { label: '百分比(%)', prop: 'b' }
  //     ];
  //     let data = [];
  //     let xAxisData = [];
  //     let series0data = [];
  //     finalData.forEach(item => {
  //       xAxisData.push(item);
  //       series0data.push(1);
  //       data.push({
  //         d: item,
  //         v: 1,
  //         b: percentage(item[1],finalDataCount)
  //       });
  //     });
  //     resolve({
  //       key: 'querytaskHospitalDistribution',
  //       value: {
  //         header: {
  //           index: 8,
  //           title: '药店定位',
  //           name: '药店定位'
  //         },
  //         table: { header, data, finalDataCount },
  // echart:[
  //   {        echartType: 'bar',
  //   echartOption: {
  //     xAxis: {
  //       type: 'category',
  //       data: xAxisData
  //     },
  //     series0data
  //   }}
  // ]
  //       }
  //     });
  //   });
  // },
  // 照片
  // querytaskImgs() {
  //   return new Promise(async (resolve, reject) => {
  //     let { data } = await BI[this.query.serviceType].querytaskImgs(this.query);
  //     let resp = data.data || [];

  //     let images = resp.map(item => item.imgUrl);
  //     resolve({
  //       key: 'querytaskImgs',
  //       value: {
  //         header: {
  //           index: 8,
  //           title: '拜访药店照片墙',
  //           name: '拜访药店照片墙'
  //         },
  //         images
  //       }
  //     });
  //   });
  // },
  async run(query) {
    this.query = query;
    let arr = [];
    for (let i in this) {
      if (
        this.hasOwnProperty(i) &&
        i !== 'run' &&
        typeof this[i] === 'function'
      ) {
        arr.push(this[i]());
      }
    }
    return new Promise((resolve, reject) => {
      Promise.all(arr)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};
